import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06492d64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-color-block" }


export default /*#__PURE__*/_defineComponent({
  __name: 'TextColorButton',
  props: {
  color: {
    type: String,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock(_component_Button, { class: "text-color-btn" }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default"),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "text-color-block-content",
          style: _normalizeStyle({ backgroundColor: __props.color })
        }, null, 4)
      ])
    ]),
    _: 3
  }))
}
}

})